import { render, staticRenderFns } from "./marker.vue?vue&type=template&id=4cffd6c2&scoped=true"
import script from "./marker.vue?vue&type=script&lang=js"
export * from "./marker.vue?vue&type=script&lang=js"
import style0 from "./marker.vue?vue&type=style&index=0&id=4cffd6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffd6c2",
  null
  
)

export default component.exports